import React from "react";
import { Route, Switch, useHistory } from "react-router";
import { Session, Posing as CogPosing } from "@collectivehealth/cog";
import { ROUTES, QUERY_PARAMS } from "constants/routing";
import useQueryParams from "hooks/useQueryParams";
import { navigateTo } from "utils/navigation";

export default function Posing({ children }) {
  const history = useHistory();
  const queryParams = useQueryParams();
  const subdomain = queryParams[QUERY_PARAMS.SUBDOMAIN];
  const env = queryParams[QUERY_PARAMS.ENV];
  const port = queryParams[QUERY_PARAMS.PORT];
  const poseuid = queryParams[QUERY_PARAMS.POSEUID];
  const userId = poseuid && parseInt(poseuid, 10);

  function handlePosing() {
    Session.endSession();
    CogPosing.requestLoginToken({ subdomain, userId, env, port })
      .then(Session.beginSession)
      .then(() => navigateTo(history, ROUTES.LANDING));
  }

  return (
    <Switch>
      <Route path={ROUTES.POSING} render={handlePosing} exact={true} strict={true} />
      <Route render={() => children} />
    </Switch>
  );
}
